import firebase from 'firebase/app';
import moment from 'moment';
import axios from 'axios';

const state = {
  integrations: [],
  available_integrations: [],
};

const mutations = {
  LOAD_DATA(state, data) {
    state.integrations = data;
  },
  add_integration(state, data) {
    state.integrations = [...state.integrations, data];
  },
  set_available_integrations(state, data) {
    state.available_integrations = data;
  },
};

const actions = {
  get_integrations: async ({ commit, rootGetters }) => {
    try {
      const organizationDoc = await firebase
        .firestore()
        .collection('organizations')
        .doc(rootGetters['auth/get_user'].orgId)
        .get();

      const { integrations = [] } = organizationDoc.data();

      commit('LOAD_DATA', integrations);
    } catch (error) {
      commit('LOAD_DATA', []);
    }
  },
  get_available_integrations: async ({ commit }) => {
    const { docs: integrations } = await firebase
      .firestore()
      .collection('integrations')
      .get();

    const availableIntegrations = integrations.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    commit('set_available_integrations', availableIntegrations);
  },
  add_integration: async ({ commit, rootGetters }, payload) => {
    const organizationDoc = await firebase
      .firestore()
      .collection('organizations')
      .doc(rootGetters['auth/get_user'].orgId);

    const { integrations = [] } = (await organizationDoc.get()).data();

    const { id, label } = payload;

    const integration = {
      id,
      label,
      created: moment().format(),
      active: true,
    };

    await organizationDoc.update({
      integrations: [...integrations, integration],
    });

    commit('add_integration', integration);
  },
  add_credential: async ({ commit, rootGetters }, payload) => {
    const { name, value, prefix } = payload;

    return axios.post(
      `${process.env.VUE_APP_DOMAIN}/api/v1/secret/add_secret`,
      {
        name: `${prefix}_${name}_${rootGetters['auth/get_user'].orgId}`,
        value,
      }
    );
  },
  verify_sia_integration: async ({ commit }, payload) => {
    const { username, password, scac } = payload;

    try {
      await axios.post(
        `${process.env.VUE_APP_DOMAIN}/api/v1/integrations/sia/verify`,
        {
          username,
          password,
          scac,
        }
      );
    } catch (error) {
      throw new Error('SIA verification unsuccessful!');
    }
  },

  verify_portpro_integration: async ({ commit }, payload) => {
    const { accessToken } = payload;

    try {
      await axios.get(
        `${process.env.VUE_APP_DOMAIN}/api/v1/integrations/portpro/getAllLoads?accessToken=${accessToken}`
      );
    } catch (error) {
      throw new Error('PORTPRO verification unsuccessful!');
    }
  },

  verify_oocl_integration: async ({ rootGetters }, payload) => {
    const { username, password } = payload;
    const orgId = rootGetters['auth/get_user'].orgId;

    try {
      await axios.get(
        `${process.env.VUE_APP_DOMAIN}/api/v1/integrations/oocl/verify?username=${username}&password=${password}&orgId=${orgId}`
      );
    } catch (error) {
      throw new Error('OOCL verification unsuccessful!');
    }
  },

  sync_loads: async ({ rootGetters }) => {
    try {
      await axios.get(
        `${process.env.VUE_APP_DOMAIN}/api/v1/integrations/portpro/getAllLoads?orgId=${rootGetters['auth/get_user'].orgId}`
      );
    } catch (error) {
      throw new Error('Error syncing loads from PORTPRO');
    }
  },
};

const getters = {
  get_integration: (state) => (id) => {
    return state.integrations.find(({ id: iId }) => iId === id);
  },
  get_integrations(state) {
    return state.integrations;
  },
  get_available_integrations(state) {
    return state.available_integrations;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
